
import React from 'react';
import { Award } from 'lucide-react';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardFooter, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { User } from '@/types/userRole';

interface UserCardProps {
  user: User;
  points: number;
}

const UserCard: React.FC<UserCardProps> = ({ user, points }) => {
  return (
    <Card>
      <CardHeader className="text-center">
        <div className="mx-auto bg-primary-blue w-20 h-20 rounded-full flex items-center justify-center mb-4">
          <span className="text-white text-3xl font-bold">{user.name.charAt(0)}</span>
        </div>
        <CardTitle>{user.name}</CardTitle>
        <CardDescription>{user.email}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-center p-4 bg-blue-50 rounded-lg">
          <Award className="h-6 w-6 text-primary-blue mr-2" />
          <div>
            <p className="text-sm text-gray-500">Total Points</p>
            <p className="text-3xl font-bold text-primary-blue">{points}</p>
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <div className="w-full text-center text-sm text-gray-500">
          {user.isAdmin ? (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-purple-100 text-purple-800">
              Admin User
            </span>
          ) : (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-green-100 text-green-800">
              Regular User
            </span>
          )}
        </div>
      </CardFooter>
    </Card>
  );
};

export default UserCard;
